import HeaderButton from "./HeaderButton";
import OrganizationLabel from "./OrganizationLabel";
import posthogEvents from "@app/config/posthog/posthog-events";
import { useUserStore } from "@app/state/store";
import Icon from "@lib/common/components/Icon/Icon";
import OrganizationSwitcher from "@lib/iam/components/OrganizationSwitcher/OrganizationSwitcher";
import { Popover, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { isNil, size } from "lodash-es";
import { usePostHog } from "posthog-js/react";

export default function OrganizationSwitcherButton() {
  const user = useUserStore();
  const [opened, popoverControl] = useDisclosure(false);
  const posthog = usePostHog();

  if (isNil(user)) {
    return null;
  }

  if (size(user.organizations) <= 1) {
    return <OrganizationLabel />;
  }

  return (
    <Popover opened={opened} onDismiss={popoverControl.close} width={450} withArrow arrowPosition="center">
      <Popover.Target>
        <Tooltip label="Switch organization">
          <HeaderButton
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
              event.preventDefault();
              event.stopPropagation();
              posthog.capture(posthogEvents.page_header.organization_switcher_button_click);
              popoverControl.toggle();
            }}
            leftSection={<Icon name="buildings" variant="solid" />}
            data-expanded={opened}
          >
            {user.current_organization.name}
          </HeaderButton>
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown>
        <OrganizationSwitcher onOrganizationSelection={popoverControl.close} />
      </Popover.Dropdown>
    </Popover>
  );
}
